import React from "react";
import "./MissionVision.css";
import { FaRocket, FaEye, FaLayerGroup } from "react-icons/fa"; // icons

const MissionVision = () => {
  const data = [
    {
      icon: <FaRocket />,
      title: "Our Mission",
      desc: "To provide businesses with affordable, high-quality printing solutions that reduce costs while maintaining global standards."
    },
    {
      icon: <FaEye />,
      title: "Our Vision",
      desc: "To become Nigeria’s most trusted printing and office supply partner, combining international expertise with local service."
    },
    {
      icon: <FaLayerGroup />,
      title: "Our Core Values",
      desc: "To build with integrity, deliver with consistency, and support every project with genuine partnership, technical expertise, and global-quality solutions."
    }
  ];

  return (
    <section className="mission-vision">
      <div className="mission-vision-container">
        {data.map((item, index) => (
          <div className="mv-card" key={index}>
            <div className="mv-icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MissionVision;
